import options from './folder-path.component';

export default {
    selector: 'dtFolderPath',
    options
};



// WEBPACK FOOTER //
// ./app/common/folder-path/index.js